import {RrcEp10WasteManifestEntity} from "@ots-frontend/ots-data";
import {Card, Divider, Grid, Group, Text, Title} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {DefaultText} from "../../text/DefaultText/DefaultText";
import { FormattedDatabaseCode } from "../../text/FormattedDatabaseCode/FormattedDatabaseCode";
import { FormattedDateTime } from "../../date/FormattedDateTime/FormattedDateTime";
import { FormattedQuantity } from "../../text/FormattedQuantity/FormattedQuantity";

export type RrcEp10WasteManifestDetailsProps = {
  rrcEp10WasteManifest: RrcEp10WasteManifestEntity
}

export const RrcEp10WasteManifestProfileDetails = (props: RrcEp10WasteManifestDetailsProps) => {
  const {rrcEp10WasteManifest} = props;

  const {t} = useTranslation(["common"]);

  return (
    <Grid>
      <Grid.Col span={12}>
        <Card shadow="sm" padding="lg" radius="md" withBorder>

          <Group position="apart" pb="sm">
            <Title order={4}>{
              t("common.entity.rrcep10wastemanifest.profile.info.section.details.label", "Details")}
            </Title>
          </Group>

          <Divider/>

          <Grid grow gutter="xs">
            <Grid.Col span={12}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.date", "Date")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <FormattedDateTime date={rrcEp10WasteManifest.manifestDttm} />
              </Text>
            </Grid.Col>
          </Grid>
          <Grid grow gutter="xs">
            <Grid.Col span={12}>
              <Divider variant="dashed"/>
            </Grid.Col>
            <Grid.Col span={12}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.wasteid", "Waste ID")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.waste1Id} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={12}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.wastetype", "Waste Type")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <FormattedDatabaseCode value={rrcEp10WasteManifest.waste1Type}/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.wastequantity", "Waste Quantity")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <FormattedQuantity value={rrcEp10WasteManifest.waste1Quantity} defaultValue="(Not Defined)" />
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.wasteunit", "Waste Unit")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <FormattedDatabaseCode value={rrcEp10WasteManifest.waste1QuantityUnit} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.wastenormreading", "Waste NORM Reading (uR/hr)")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <FormattedQuantity value={rrcEp10WasteManifest.wasteNormReading} defaultValue="(Not Defined)" />
              </Text>
            </Grid.Col>
          </Grid>
          <Grid grow gutter="xs">
            <Grid.Col span={12}>
              <Divider variant="dashed"/>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.genorgname.label", "Gen. Org Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.generatorOrgName} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.genp5number.label", "Gen. P5 #")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.generatorP5Number} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={12} mt="md">
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.facilityname.label", "Gen. Facility Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.generatorLocationFacilityName} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.leasename.label", "Gen. Lease Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.generatorLocationFacilityName} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.leasenumber.label", "Gen. Lease #")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.generatorLocationLeaseNumber} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.gasplantnumber.label", "Gen. Gas Plant #")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.generatorLocationGasPlantNumber} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.apinumber.label", "Gen. API #")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.generatorLocationApiNumber} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.otheridentifier.label", "Gen. Other Identifier")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.generatorLocationOtherIdentifier} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.gps.label", "Gen. GPS")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                {rrcEp10WasteManifest.generatorLocationLatCoord && rrcEp10WasteManifest.generatorLocationLongCoord ?
                  `${rrcEp10WasteManifest.generatorLocationLatCoord}, ${rrcEp10WasteManifest.generatorLocationLongCoord}` :
                  "(Not Defined)"
                }
              </Text>
            </Grid.Col>
            <Grid.Col span={12} mb="md">
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.county.label", "Gen. County")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.generatorLocationCounty} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.contactname.label", "Gen. Contact Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.generatorContactName} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.contactphone.label", "Gen. Contact Phone #")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.generatorContactPhone} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.contactemail.label", "Gen. Contact Email")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.generatorContactEmail} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={12} mt="md">
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.signature.label", "Gen. Certification")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.generatorSignedByName} defaultValue="(Not Defined)"/>
                {rrcEp10WasteManifest.generatorSignedDttm && <FormattedDateTime date={rrcEp10WasteManifest.generatorSignedDttm} />}
              </Text>
            </Grid.Col>
          </Grid>
          <Grid grow gutter="xs">
            <Grid.Col span={12}>
              <Divider variant="dashed"/>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.transorgname.label", "Transporter Org Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.transporterOrgName} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.transpermitnumber.label", "Transporter Permit #")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.transporterPermitNumber} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6} mt="md">
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.transcontactname.label", "Transporter Contact Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.transporterContactName} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.transcontactphone.label", "Transporter Contact Phone #")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.transporterContactPhone} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.transcontactemail.label", "Transporter Contact Email")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.transporterContactEmail} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={12} mt="md">
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.transsignature.label", "Transporter Certification")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.transporterSignedByName} defaultValue="(Not Defined)"/>
                {rrcEp10WasteManifest.transporterSignedDttm && <FormattedDateTime date={rrcEp10WasteManifest.transporterSignedDttm} />}
              </Text>
            </Grid.Col>
          </Grid>
          <Grid grow gutter="xs">
            <Grid.Col span={12}>
              <Divider variant="dashed"/>
            </Grid.Col>
            <Grid.Col span={12}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.recorgname.label", "Receiver Org Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.receiverOrgName} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6} mt="md">
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.reclocation.label", "Receiver Facility Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.receiverLocationFacilityName} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.recpermitnumber.label", "Receiver Facility Permit #")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.receiverLocationFacilityPermitNumber} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.reccontactname.label", "Receiver Contact Name")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.receiverContactName} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.reccontactphone.label", "Receiver Contact Phone #")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.receiverContactPhone} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.reccontactemail.label", "Receiver Contact Email")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.receiverContactEmail} defaultValue="(Not Defined)"/>
              </Text>
            </Grid.Col>
            <Grid.Col span={12} mt="md">
              <Text ta="left" fz="sm" weight={500} mt="md">
                {t("common.entity.rrcep10wastemanifest.profile.info.field.recsignature.label", "Receiver Certification")}
              </Text>
              <Text ta="left" c="dimmed" fz="xs">
                <DefaultText value={rrcEp10WasteManifest.receiverSignedByName} defaultValue="(Not Defined)"/>
                {rrcEp10WasteManifest.receiverSignedDttm && <FormattedDateTime date={rrcEp10WasteManifest.receiverSignedDttm} />}
              </Text>
            </Grid.Col>
          </Grid>
        </Card>
      </Grid.Col>
    </Grid>
  );
};
